module.exports = __webpack_public_path__ + "img/p25.761b254e.svg";